
import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import config from "../config/config";
import { useParams } from "react-router";
import api, { setupAxiosInterceptors } from "./api";
import { message } from "antd";

const UserContext = createContext();

export const UserContextProvider = ({ children }) => {
  const [token, setToken] = useState(() => {
    const storedToken = localStorage.getItem('token');
    try {
      return storedToken ? JSON.parse(storedToken) : null;
    } catch {
      return storedToken || null;
    }
  });
  
    const [lang, setLang] = useState(localStorage.getItem("lang"));
  const [categorys, setCategorys] = useState([]); // ✅ always an array
  const [categorysbyid, setCategorysByid] = useState();
  const [bigProjects, setBigProjects] = useState([]);
  const [totalBigProjects, setTotalBigProjects] = useState(0); 
  const [courseById, setCourseById] = useState("Barchasi");
  const [categoryId, setCategoryId] = useState(null);
  const [products, setProducts] = useState([]);
  const [zapchastproducts, setZapchastProducts] = useState()
  const [active, setActive] = useState("Barchasi");
  const [user, setUser] = useState();
  const [productImages, setProductImages] = useState();
  const [images, setImages] = useState([]);
  const [password, setPassword] = useState();
  const [username, setUsername] = useState();
  const [similar, setSimilar] = useState();
  const [fileList, setFileList] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();
  const [data, setData] = useState();
  const [parentid, setParentId] = useState();
  const [category, setCategory] = useState();
  const [subcategory, setSubcategory] = useState();
  const [news, setNews] = useState([]); // ✅ CORRECT
  const [brands, setBrands] = useState([]);
  const [countPage, setCountPage] = useState();
  const [showimg, setShowimg] = useState(false)
  const [currentPage, setCurrentPage] = useState(
    JSON.parse(localStorage.getItem("page")),
    1
  );
  const [totalProducts, setTotalProducts] = useState(0);
  const [pagesCount, setPagesCount] = useState(0);
  const [refresh, setRefresh] = useState(false);

  const [loading, setLoading] = useState(false);

  const [banners, setBanners] = useState([]);
  const [totalBanners, setTotalBanners] = useState(0);


  const [order, setOrder] = useState();
  // const GetCategory = () => {
  //   axios.get(`https://api.protools.uz/v1/categories`).then((response) => {
  //     // setTotal(JSON.parse(response.headers["x-pagination"]));
  //     setCategory(response?.data?.data);
  //     console.log(response);
  //   });
  // };

  
  
  const GetCategory = async (page = 1) => {
    setLoading(true);
    try {
      const response = await api.get(`/category/?page=${page}`);
      const data = Array.isArray(response.data) ? response.data : response.data?.data || [];
      setCategorys(data);
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategorys([]);
    } finally {
      setLoading(false);
    }
  };
  const GetProducts = async (page = 1) => {
    // Check token more thoroughly
    if (!token || !token.access) {
      console.log('No valid token available for products request');
      return [];
    }

    setLoading(true);
    try {
      console.log('Making request with token:', token.access); // Debug log
      const response = await api.get(`/products/?page=${page}`, {
        headers: {
          'Authorization': `Bearer ${token.access}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('Full API response:', response); // Debug log

      // Handle different possible response structures
      let data = [];
      if (Array.isArray(response.data)) {
        data = response.data;
      } else if (response.data?.data) {
        data = Array.isArray(response.data.data) ? response.data.data : [response.data.data];
      } else if (response.data?.results) {
        data = response.data.results;
      }

      setProducts(data);
      setTotalProducts(response.data?.count || response.data?.totalCount || data.length);
      return data;
    } catch (error) {
      console.error('Detailed error:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      
      if (error.response?.status === 401) {
        message.error('Session expired. Please login again.');
        setToken(null);
        localStorage.removeItem('token');
      } else {
        message.error(`Error loading products: ${error.message}`);
      }
      
      setProducts([]);
      return [];
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log('Current token:', token);
    console.log('Current products state:', products);
  }, [token, products]);
  

  const GetBigProjects = async (page = 1) => {
    setLoading(true);
    try {
      const response = await api.get(`/bigproject/?page=${page}`);
      setBigProjects(response.data.data || []);
      setTotalBigProjects(response.data.totalCount || 0);
    } catch (error) {
      console.error("Error fetching big projects:", error);
    } finally {
      setLoading(false);
    }
  };

  const GetOrders = async (page = 1) => {
    if (!token || !token.access) {
      console.log('No valid token available for orders request');
      return [];
    }

    setLoading(true);
    try {
      const response = await api.get(`/orders/?sortBy=createdAt&orderBy=DESC&page=${page}`);
      setOrder(response.data);
      setTotalProducts(response.data?.totalCount || 0); // Use the setter from context
      setPagesCount(response.data?.pagesCount || 0);
    } catch (error) {
      console.error("Error fetching orders:", error);
      if (error.response?.status === 401) {
        setToken(null);
        localStorage.removeItem('token');
      }
    } finally {
      setLoading(false);
    }
  };
  const GetSubCategory = (fuckingPageNumber) => { 
    // servies USLUGI 
    setLoading(true);
    axios
      .get(
        `https://api.unit-group.uz/service/?page=${fuckingPageNumber ? fuckingPageNumber : 1
        }`,
        {}
      )
      .then((response) => {
        setLoading(false);
        setSubcategory(response?.data?.data);
        setTotalProducts(response?.data?.totalCount);
        setPagesCount(response?.data?.pagesCount);
      });
  };
 

  const GetBrands = async (page = 1) => {
    if (!token || !token.access) {
      console.log('No valid token available for brands request');
      return [];
    }

    setLoading(true);
    try {
      const response = await api.get(`/partner/?page=${page}`);
      const data = Array.isArray(response.data) ? response.data : response.data?.data || [];
      setBrands(data);
      setTotalProducts(response.data?.totalCount || response.data?.count || 0);
    } catch (error) {
      console.error("Error fetching brands:", error);
      if (error.response?.status === 401) {
        setToken(null);
        localStorage.removeItem('token');
      }
      setBrands([]);
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    setupAxiosInterceptors(token, () => {
      // Handle unauthorized (e.g., logout)
      setToken(null);
      localStorage.removeItem('token');
    });
  }, [token]);

  useEffect(() => {
    if (token) {
      localStorage.setItem("token", typeof token === "string" ? token : JSON.stringify(token));
    } else {
      // Do NOT remove token here blindly — only if it's explicitly logged out.
      // Or comment it out:
      // localStorage.removeItem("token");
    }
  
    if (currentPage) {
      localStorage.setItem("page", JSON.stringify(currentPage));
    }
  
    if (lang) {
      localStorage.setItem("lang", lang);
    } else {
      localStorage.removeItem("lang");
    }
  }, [token, lang, currentPage]);
  
  

const GetNews = (fuckingPageNumber = 1) => {
  axios
    .get(`https://api.unit-group.uz/news/?page=${fuckingPageNumber}`)
    .then((response) => {
      setNews(response.data); // ✅ this is the correct line
      setTotalProducts(response.data.length); // optional
    })
    .catch((error) => {
      console.error("Error fetching news:", error);
    });
};
const updateToken = (newToken) => {
  if (typeof newToken === 'object' && newToken.access) {
    localStorage.setItem('token', JSON.stringify(newToken));
    setToken(newToken);
  } else {
    localStorage.setItem('token', newToken);
    setToken(newToken);
  }
};


const GetBanners = async (page = 1) => {
  try {
    const res = await api.get(`/banner/?page=${page}`);
    console.log("Banner API response:", res.data);

    setBanners(Array.isArray(res.data) ? res.data : res.data.results || res.data.data || []);
    setTotalBanners(res.data.count || 0);
  } catch (error) {
    console.error("Failed to fetch banners:", error);
  }
};


useEffect(() => {
  if (token) {
    localStorage.setItem("token", typeof token === "string" ? token : JSON.stringify(token));
  }
}, [token]);

useEffect(() => {
  GetBanners(1);
}, []);


// Removed redundant useEffect - GetProducts is already called in pageLocation useEffect


// In your UserContext provider, add this useEffect
useEffect(() => {
  console.log('Current products state:', products);
}, [products]);

useEffect(() => {
  console.log('Current images state:', images);
}, [images]);

  const pageLocation = window.location.pathname;
  useEffect(() => {
    // Only call public APIs that don't require authentication
    GetCategory();
    GetNews();
    GetBanners();
    
    // Only call authenticated APIs if user is logged in
    if (token && token.access) {
      GetProducts();
      GetOrders();
      GetBrands(); // This might require auth, so moved inside the condition
    }
  }, [pageLocation, token]);

  const deleteOrder = async (orderId) => {
    setLoading(true);
    try {
      await api.delete(`/orders/${orderId}`, {
        headers: {
          Authorization: `Bearer ${token?.access}`
        }
      });
      message.success('Buyurtma muvaffaqiyatli o\'chirildi');
      GetOrders(currentPage); // Refresh the orders list
    } catch (error) {
      console.error("Error deleting order:", error);
      message.error('Buyurtmani o\'chirishda xatolik yuz berdi');
    } finally {
      setLoading(false);
    }
  };
  

  // const AddBanner = (bannerData) => {
  //   axios
  //     .post('https://api.protools.uz/v1/banners', bannerData, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     })
  //     .then((response) => {
  //       console.log(response.data);
  //       GetBanners();
  //       window.location.reload();
  //     })
  //     .catch((error) => {
  //       console.error('Error adding banner:', error);
  //       if (error.response && error.response.status === 401) {
  //         localStorage.removeItem('token');
  //       }
  //     });
  // };

  const value = {
    // users,
    // setUsers,
    token,
    setToken: updateToken,
    loading,
    setLoading,
    categorys,
    setCategorys,
    totalBanners,
  setTotalBanners,
    products,
    setProducts,
    courseById,
    setCourseById,
    active,
    setActive,
    user,
    setUser,
    productImages,
    setProductImages,
    categoryId,
    totalProducts,
    setTotalProducts,
    refresh,
    setRefresh,
    setCategorysByid,
    categoryId,
    setCategoryId,
    categorysbyid,
    currentPage,
    setCurrentPage,
    setCategorysByid,
    brands,
    setBrands,
    images,
    setImages,
    password,
    setPassword,
    username,
    setUsername,
    similar,
    setSimilar,
    lang,
    setLang,
    page,
    setPage,
    total,
    setTotal,
    data,
    setData,
    parentid,
    category,
    setCategory,
    setParentId,
    GetCategory,
    news,
    setNews,
    GetProducts,
    GetNews,
    banners,
    setBanners,
    bigProjects,
    setBigProjects,
    deleteOrder,
    GetBigProjects,
    GetBanners,
    subcategory,
    setSubcategory,
    GetBrands,
    GetSubCategory,
    countPage,
    setCountPage,
    pagesCount,
    banners,
    setBanners,
    GetBanners,
    setPagesCount,
    order,
    setOrder,
    zapchastproducts, setZapchastProducts,
    GetOrders,
    showimg, setShowimg,
    fileList, setFileList
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUserContext = () => useContext(UserContext);